import { createContext } from 'react'

import { DEFAULT_DATE_LOCALE } from '../constants/date'

export const DateLocale = createContext(DEFAULT_DATE_LOCALE)
